var map = {
	"./chapter1/CAPITOLO_01_01.mp4": 2273,
	"./chapter1/CAPITOLO_01_02.mp4": 7225,
	"./chapter1/CAPITOLO_01_05.mp4": 507,
	"./chapter1/CAPITOLO_01_06.mp4": 9318,
	"./chapter1/CAPITOLO_01_07.mp4": 8570,
	"./chapter1/CAPITOLO_01_08.mp4": 9813,
	"./chapter1/CAPITOLO_01_09.mp4": 9040,
	"./chapter1/CAPITOLO_01_10.mp4": 5640,
	"./chapter1/Capitolo_0.mp4": 6930,
	"./chapter1/chapter1Videos": 4850,
	"./chapter1/chapter1Videos.ts": 4850,
	"./chapter2/Capitolo_2_01_confidato.mp4": 5246,
	"./chapter2/Capitolo_2_01_non_confidato.mp4": 3546,
	"./chapter2/Capitolo_2_02_con Vis.mp4": 9023,
	"./chapter2/Capitolo_2_02_opporsi a Vis.mp4": 1141,
	"./chapter2/Capitolo_2_03_confidarsi con Giovanni.mp4": 3644,
	"./chapter2/Capitolo_2_04_messaggi con gli altri.mp4": 1489,
	"./chapter2/Capitolo_2_05_ mex corretti.mp4": 3423,
	"./chapter2/Capitolo_2_05_ mex non  corretti.mp4": 3323,
	"./chapter2/Capitolo_2_06_mex a Vis.mp4": 3648,
	"./chapter2/Capitolo_2_07_messaggio audio(fine cap 2).mp4": 9028,
	"./chapter2/Capitolo_2_ALESSANDRO.mp4": 82,
	"./chapter3/antonioChoice.mp4": 286,
	"./chapter3/cap3_magazzino_aiutano.mp4": 7777,
	"./chapter3/cap3_magazzino_attesa.mp4": 9242,
	"./chapter3/cap3_magazzino_circospezione.mp4": 7599,
	"./chapter3/cap3_magazzino_moto.mp4": 6206,
	"./chapter3/cap3_magazzino_motoPaglia.mp4": 5648,
	"./chapter3/cap3_magazzino_rumore.mp4": 5582,
	"./chapter3/cap3_magazzino_sbirro.mp4": 6890,
	"./chapter3/cap3_magazzino_scappano.mp4": 8261,
	"./chapter3/capitolo_3 _1  ok.mp4": 4618,
	"./chapter3/capitolo_3_1 err.mp4": 8237,
	"./chapter3/capitolo_3_2 err.mp4": 5722,
	"./chapter3/capitolo_3_2 ok.mp4": 6774,
	"./chapter3/chatTemp.mp4": 8635,
	"./chapter3/choiceYussef.mp4": 8066,
	"./chapter3/yuChoice.mp4": 4885,
	"./chapter4/capitolo_4_Antonio_01.mp4": 2521,
	"./chapter4/capitolo_4_Antonio_02.mp4": 9433,
	"./chapter4/capitolo_4_Antonio_03.mp4": 3489,
	"./chapter4/capitolo_4_Antonio_04.mp4": 7882,
	"./chapter4/capitolo_4_Antonio_06.mp4": 7009,
	"./chapter4/capitolo_4_Antonio_07.mp4": 764,
	"./chapter5/cap05-02-option-01_video.mp4": 3810,
	"./chapter5/cap05-02-option-02_video.mp4": 2650,
	"./chapter5/cap05-02.mp4": 1006,
	"./chapter5/cap05-03_video.mp4": 5966,
	"./chapter5/cap05-03_video_no scelta.mp4": 1359,
	"./chapter5/cap051-01-option-04-02-01-01.mp4": 7312,
	"./chapter5/cap051-01-option-04-02-01-02_video01.mp4": 9686,
	"./chapter5/cap051-01-option-04-02-02-01.mp4": 4387,
	"./chapter5/cap051-04-01_video01.mp4": 983,
	"./chapter5/cap051-04-01_video02.mp4": 7963,
	"./chapter5/cap051-04-01_video03.mp4": 3287,
	"./chapter5/cap051-04-02_video01.mp4": 7374,
	"./chapter5/cap051-04-02_video02.mp4": 589,
	"./chapter5/cap051-04_video01.mp4": 1271,
	"./chapter5/cap052-01-option-04-02-02-02_video.mp4": 2887,
	"./chapter5/cap052-04-01_video01.mp4": 1150,
	"./chapter5/cap052-04-02_video01.mp4": 2244,
	"./chapter5/cap052-04-02_video02.mp4": 8127,
	"./chapter5/cap052-04-option-04-02-01-02_video01.mp4": 1510,
	"./chapter5/cap052-04-option-04-02-02-02_video.mp4": 3373,
	"./chapter5/chatTemp (copy).mp4": 8321,
	"./chapter5/chatTemp.mp4": 7915,
	"./endings/Finale bad.mp4": 8067,
	"./endings/Finale best.mp4": 7027,
	"./endings/Finale good.mp4": 3817,
	"./endings/Finale worst.mp4": 6740
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2355;